import React, {useState} from 'react';
import './MainPage.scss';
import SideBar from './SideBar';
import MainWindow from './MainWindow';
import Header from "./Header";

const MainPage = () => {
    const [showMenuLabels, setShowMenuLabels] = useState(false);
    const toggleShowMenuLabels = () => {
        setShowMenuLabels(!showMenuLabels);
    };

    return (
        <div className='app'>
            <Header toggleShowMenuLabels={toggleShowMenuLabels} showMenuLabels={showMenuLabels}/>
            <div className='mainPage'>
                <SideBar showMenuLabels={showMenuLabels} />
                <MainWindow showMenuLabels={showMenuLabels} />
            </div>
        </div>
    );
}

export default MainPage;
